import React from 'react';
import { observer } from 'mobx-react';
import { imageSrc } from 'apps/file/utils';

import { HighlightedSelection } from 'apps/autocomplete/views/highlightedSelection';
import { conf as mainConf } from 'apps/config.yaml';

import { Option, OptionWrapper, OwnerAvatar } from 'libs/forms/styles';

export const ProfilesAutoComplete = observer(
  ({ app, highlighted, selection, onMouseOver, onClick, scrollRef }) => (
    <OptionWrapper
      highlighted={highlighted}
      onMouseOver={onMouseOver}
      onClick={onClick}
      ref={scrollRef}
    >
      <Option key={app.username} highlighted={highlighted}>
        <OwnerAvatar
          size='22px'
          src={imageSrc(
            app.avatar,
            app.imageFallbackPath,
            mainConf.imgSizes.profile.small,
          )}
          noMarginTop
        />
        <HighlightedSelection
          optionText={`${app.username} (${app.fullName})`}
          selection={selection}
          inserveHighlighting
        />
      </Option>
    </OptionWrapper>
  ),
);
